import { useParams } from "react-router-dom";
import { useDataApiArticle } from "../../Hooks/useDataArticlesApi";
import React from "react";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ArticleEdit } from "../../components/article/article";

// Pour récupérer le contenu en format RAW

const EditArticle: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const articleAPI = useDataApiArticle(Number.parseInt(id));

    if (!articleAPI) {
        return (<>Loading...</>)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    }

    return (
        <div>
            <ArticleEdit {...articleAPI}></ArticleEdit>
        </div>
    );
};

export { EditArticle };